module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table right-gram"
  }, [_c('thead', [_c('th', {
    class: {
      'diff-thead': !_vm.showTd
    }
  }, [_vm._v(_vm._s(_vm.tableText ? '城市' : _vm.cityText ? '省外城市' : '省份'))]), _vm._v(" "), _c('th', [_vm._v("销量占比")]), _vm._v(" "), (_vm.showTd) ? _c('th', [_vm._v("省内分布")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: [_vm.changeClass ? 'auto-height' : 'fixed-height']
  }, [_c('table', {
    staticClass: "table right-gram"
  }, [_c('tbody', _vm._l((_vm.dataList), function(item, index) {
    return _c('tr', [_c('td', {
      class: {
        'diff-thead': !_vm.showTd
      }
    }, [_c('span', {
      staticClass: "icon-box",
      class: {
        'td1': _vm.showTd && index === 0, 'td2': _vm.showTd && index === 1, 'td3': _vm.showTd && index === 2, 'td4': _vm.showTd && index === 3, 'td5': _vm.showTd && index === 4, 'td-one': !_vm.showTd && index === 0, 'td-two': !_vm.showTd && index === 1, 'td-three': !_vm.showTd && index === 2
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('td', {
      class: {
        'diff-width': !_vm.showTd
      },
      attrs: {
        "id": "bar"
      }
    }, [_c('span', {
      staticClass: "limit-width"
    }, [_vm._v(_vm._s(_vm._f("toFixedPercent")(item.ratio)))]), _c('span', {
      staticClass: "bule-bar",
      style: ({
        'background-image': _vm.backgroundImage,
        'margin-left': _vm.marginLeft,
        height: '22px',
        'margin-bottom': _vm.marginBottom,
        'border-right': 'solid 1px #2a99f1',
        display: _vm.display,
        width: _vm.barWidth[index]
      })
    })]), _vm._v(" "), (_vm.showTd) ? _c('td', {
      on: {
        "click": function($event) {
          _vm.showDataTable(item)
        }
      }
    }, [_vm._m(0, true)]) : _vm._e()])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("查看"), _c('span', {
    staticClass: "iconfont"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c31f87e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/newGtyDataCenter/table.vue
// module id = 888
// module chunks = 0